module.exports = __webpack_public_path__ + "343c60343cc5ce4a48fd58b204a350ee.pdf";